<template>
  <hic-list-page title="打印模板管理" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="编码/名称">
    <template slot="buttons">
      <el-button v-if="permission.masterdata_dict_create" class="left-pad" type="primary" @click="create" size="small"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>

    <el-table-column label="操作" width="150" align="center">
      <template slot-scope="scope">
        <!-- <el-button type="warning" icon="el-icon-c-scale-to-original" title="设计" plain circle size="mini" @click="design(scope.row)"></el-button> -->
        <el-button type="primary" icon="el-icon-edit" title="编辑" plain circle size="mini" @click="edit(scope.row)"></el-button>
        <el-popconfirm title="确定要删除吗？" @onConfirm="del(scope.row)" @confirm="del(scope.row, scope.$index)" iconColor="red">
          <el-button slot="reference" type="danger" icon="el-icon-delete" title="删除" plain circle size="mini" class="left-pad"></el-button>
        </el-popconfirm>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" sortable="custom">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="info(row)">
          <b>{{ row.name }}</b>
        </el-link>
      </template>
    </el-table-column>
    <el-table-column label="编码" prop="code" sortable="custom"> </el-table-column>
    <el-table-column label="应用" prop="sys" sortable="custom" :filters="dict.MySys" :filter-multiple="false" column-key="sys">
      <template #default="{ row }">
        {{ row.sys | dictText("MySys") }}
      </template>
    </el-table-column>
    <el-table-column label="备注" prop="memo"> </el-table-column>
    <Editor v-model="entity" :visible.sync="meta.showEditor" @saved="page" />
    <Info :visible.sync="meta.showInfo" v-model="entity" />
  </hic-list-page>
</template>

<script>
  import api from "./api";
  // import { getLodop } from "@/common/LodopFuncs";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      Editor: () => import("./editor"),
      Info: () => import("./info"),
    },
    data() {
      return {
        condition: {
          keyword: null,
          sort: "id",
          asc: false,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        searchLoading: false,
        meta: {
          loading: false,
          showEditor: false,
          showInfo: false,
        },
        entities: {
          items: [],
        },
        selectedDict: null,
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "permission", "user"]),
    },
    mounted() {},
    methods: {
      page() {
        this.meta.loading = true;
        api.PrintTemplate.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      create() {
        this.entity = {};
        this.meta.showEditor = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.meta.showEditor = true;
      },
      del(row) {
        api.PrintTemplate.del(row.id)
          .then((res) => {
            this.$message.success("删除成功");
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      info(row) {
        this.entity = row;
        this.meta.showInfo = true;
      },
      //   design(row) {
      //     let LODOP = getLodop();
      //     if (row.content) {
      //       eval(row.content);
      //       // LODOP.ADD_PRINT_DATA("ProgramData", row.content);
      //     }
      //     LODOP.PRINT_DESIGN();
      //     // if (type == 0) {
      //     //   LODOP.PRINT();
      //     // }
      //     // if (type == 1) {
      //     //   LODOP.PREVIEW();
      //     // }
      //     // if (type == 2) {
      //     //   LODOP.PRINT_DESIGN();
      //     // }
      //     // if (type == 3) {
      //     //   LODOP.PRINT_SETUP();
      //     // }
      //     if (LODOP.CVERSION)
      //       LODOP.On_Return = (TaskID, Value) => {
      //         LODOP.GET_VALUE("ProgramCodes", 0);
      //         LODOP.On_Return = (TaskID, Value) => {
      //           row.content = Value;
      //           api.PrintTemplate.save(row)
      //             .then((res) => {
      //               this.$message.success("保存成功");
      //             })
      //             .catch((err) => {
      //               this.$message.error(err);
      //             });
      //         };
      //       };
      //   },
    },
  };
</script>
